import { render, staticRenderFns } from "./swiperWrapper.vue?vue&type=template&id=c2e4f6d8&scoped=true"
import script from "./swiperWrapper.vue?vue&type=script&lang=js"
export * from "./swiperWrapper.vue?vue&type=script&lang=js"
import style0 from "./swiperWrapper.vue?vue&type=style&index=0&id=c2e4f6d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e4f6d8",
  null
  
)

export default component.exports